import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton, DefaultButton, Toggle, Stack } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getCivilDateToday } from '@bingads-webui-universal/temporal-utitlities';
import { CronFormatter } from '@bingads-webui/cron-formatter';
import { LegacyI18n } from '@bingads-webui-campaign/report-shared';
import { ReportSchedule } from './scheduler';
import { defaultSchedule } from '../';
// Feel free to export more functions if you need
// like dismissCallback, iconClickCallback, cancelCallback ...
function FrequencyEditPanel(props) {
  const {
    data,
    onSave,
    onCancel,
  } = props;

  const defaultInitSchedule = {
    isScheduleEnabled: false,
    AttachFileToEmail: false,
    EmailRecipients: [],
    Cron: '0 12 * * 0 *',
    StartTime: getCivilDateToday().toString(),
    EndTime: getCivilDateToday().plus({ months: 3 }).toString(),
    FileFormat: 'Xlsx',
  };

  const [isScheduleEnabled, setIsScheduleEnabled] = useState((typeof data.Cron === 'string' && data.Cron !== '') || defaultInitSchedule.isScheduleEnabled);

  const initSchedule = {
    AttachFileToEmail: data.AttachFileToEmail || defaultInitSchedule.AttachFileToEmail,
    EmailRecipients: data.EmailRecipients || defaultInitSchedule.EmailRecipients,
    Cron: (data.Cron === null || data.Cron === undefined || data.Cron === '') ? defaultInitSchedule.Cron : data.Cron,
    StartTime: data.StartTime || defaultInitSchedule.StartTime,
    EndTime: data.EndTime || defaultInitSchedule.EndTime,
    Format: data.FileFormat || defaultInitSchedule.FileFormat,
  };

  const i18n = useContext(I18nContext);

  const [settings, setSettings] = useState(initSchedule);

  const legacyI18n = useContext(LegacyI18n);
  const cronFormatter = new CronFormatter({ i18n: legacyI18n });

  function setScheduleHanlder(newData) {
    setSettings(cur => ({ ...cur, ...newData }));
  }

  function changeIsScheduleEnabled(event, checked) {
    setIsScheduleEnabled(checked);
  }

  function onSaveClick() {
    const newSettings = isScheduleEnabled ? settings : defaultSchedule;
    onSave(newSettings);
  }

  function onCancelClick() {
    onCancel();
  }

  const scheduleThisReportText = i18n.getString(_TL_('Schedule this report'));

  const isSaveButtonEnabled = !isScheduleEnabled || (settings.EmailRecipients && settings.EmailRecipients.length > 0);

  return (
    <div className="frequency-edit-panel">
      <div>
        <Toggle
          checked={isScheduleEnabled}
          onText={scheduleThisReportText}
          offText={scheduleThisReportText}
          onChange={changeIsScheduleEnabled}
        />
      </div>
      <ReportSchedule
        isScheduleEnabled={isScheduleEnabled}
        i18n={i18n}
        cronFormatter={cronFormatter}
        setSchedule={setScheduleHanlder}
        Cron={settings.Cron}
        StartDate={settings.StartTime}
        EndDate={settings.EndTime}
        AttachFileToEmail={settings.AttachFileToEmail}
        EmailRecipients={settings.EmailRecipients}
        FileFormat={settings.Format}
        Template={data.Template}
      />
      <Stack horizontal tokens={{ childrenGap: 8 }}>
        <PrimaryButton
          text={i18n.getString(_TL_('Save'))}
          onClick={onSaveClick}
          disabled={!isSaveButtonEnabled}
        />
        <DefaultButton
          text={i18n.getString(_TL_('Cancel'))}
          onClick={onCancelClick}
        />
      </Stack>
    </div>
  );
}

FrequencyEditPanel.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  data: PropTypes.shape({
    AttachFileToEmail: PropTypes.bool.isRequired,
    EmailRecipients: PropTypes.arrayOf(PropTypes.string).isRequired,
    Cron: PropTypes.string.isRequired,
    StartDate: PropTypes.string.isRequired,
    EndDate: PropTypes.string.isRequired,
    Format: PropTypes.string.isRequired,
    Template: PropTypes.string.isRequired, // readonly, and not part of setting
  }).isRequired,
};

export { FrequencyEditPanel };
